module.exports = __webpack_public_path__ + "images/mmm-faq-01-desktop.png";